import React from 'react'
import { Form, Formik } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { TbLoader } from "react-icons/tb";
import MyTextArea from '../../../../helpers/MyTextArea';
import { replyMessageInNote } from '../../../../helpers/Api';

const ComentariosReply = ({
    childrenReply,
    idSolicitud,
    token,
    setQuery,
    query,
}) => {


    let initialValues = {
        mensaje_padre_id: childrenReply,
        mensaje: "",
      };

      const handlerReplyMessage = async (values, setSubmitting, resetForm) => {
        try {
          const response = await replyMessageInNote(
            idSolicitud,
            token,
            values,
          );
          if (response) {
            setQuery(query + 1);
            setSubmitting(false);     
          }
        } catch (error) {
          Swal.fire("Oops", "Ha surgido un problema al postear mensaje", "error");
        } finally {
          resetForm();
        }
      };

  return (
    <Formik
        initialValues={initialValues}
        validationSchema={Yup.object().shape({
          mensaje: Yup.string().required("Este campo no puede estar vacío"),
        })}
        onSubmit={(values, { resetForm, setSubmitting }) => {
          handlerReplyMessage(values, setSubmitting, resetForm);
        }}
      >
        {(props) => (
          <Form>
            <div className="row d-flex justify-content-end">
              <div className="col-10" style={{margin: '10px'}}>
                <MyTextArea
                  type="text"
                  name={"mensaje"}
                  className="form-control"
                  placeholder="Agrega un comentario a la nota"
                />
              </div>
              <div className="col-11 mt-2 d-flex flex-row-reverse">
                <button type="submit" className="btn btn-primary">
                {!props.isSubmitting ?  'Enviar' : <TbLoader color={'rgba(255, 255, 255, 1)'} size={'1.4rem'} className="loader_login_button" /> } 
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
  )
}

export default ComentariosReply